import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { catchError, of } from 'rxjs';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { DynamicFieldService } from '../../../core/services/dynamic-field.service';
import { SchemaApiService } from '../../../core/services/schema-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationEngineService } from '../../../core/services/validation-engine.service';
import { mapBackendSchema } from '../../../core/utils/dynamic-mapper.utils';
import { DynamicFormLayout } from '../../../core/models/dynamic-form.models';
import { DynamicFormShellComponent } from '../../../feature/renderentityform/dynamic-form-shell/dynamic-form-shell';
import { TransactionToolbarComponent } from '../../../feature/renderentityform/actions/transaction-toolbar.component';
import { TaxBreakdownDrawerComponent } from '../../../partials/components/tax-dialog/tax-breakdown-drawer.component';
import { DateUtils } from '../../../core/utils/date-utils';

// import { TranslationService } from '../../../core/services/translation.service';
declare var KTToast: any;

@Component({
  selector: 'app-render-form-page',
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DynamicFormShellComponent,
    TransactionToolbarComponent,
    MatSnackBarModule,
    TaxBreakdownDrawerComponent
  ],
  templateUrl: './render-form-page.html',
})
export class RenderFormPageComponent implements OnInit {
  @Input() entity!: string;
  @Input() recId: string | undefined = undefined;
  @Output() saved = new EventEmitter<void>();
  layout!: DynamicFormLayout;
  form!: FormGroup;
  moduleCode?: string;
  recordId?: string;
  loading = true;
  activeTab: number = 0; // Default to the first tab

  showDebug = false;

  private schemaLoaded = false;

  getFieldCount(): number {
    return Object.keys(this.form.controls).length;
  }

  toggleDebug(): void {
    this.showDebug = !this.showDebug;
  }

  constructor(
    private dfs: DynamicFieldService,
    private api: SchemaApiService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private validationEngine: ValidationEngineService,
    private router: Router
  ) { }

  //   // this.entity = this.route.snapshot.paramMap.get("entity") || "invoice190";

  //   this.api.getSchema(this.entity).subscribe((schema) => {
  //     this.layout = mapBackendSchema(schema);
  //     this.form = this.dfs.buildForm(this.layout);
  //     this.loading = false;

  //     const recId = this.route.snapshot.paramMap.get('id');
  //     if (recId) this.loadRecord(recId);
  //   });
  // }
  // ngOnInit() {
  //   // 1. Get the 'entity' and 'id' from the URL path
  //   this.route.paramMap.subscribe((params) => {
  //     this.entity = params.get('entity') || '';
  //     // this.recId = params.get('id');

  //     if (this.entity) {
  //       // 2. Load the design (Schema) first
  //       this.api.getSchema(this.entity).subscribe((schema) => {
  //         this.layout = mapBackendSchema(schema);
  //         this.form = this.dfs.buildForm(this.layout);
  //         this.loading = false;

  //         // 3. If there is an ID in the URL, load the saved data
  //         if (this.recId) {
  //           this.loadRecord(this.recId);
  //         }
  //       });
  //     }
  //   });
  // }
  // ✅ Load schema only once (UI design)
  // ngOnInit(): void {
  //   this.loadSchemaOnce();
  //   // this.resetForCreate();
  // }
  
  ngOnInit(): void {

    this.route.paramMap
      .subscribe(params => {

        const module =
          params.get('module');

        const entity =
          params.get('entity');

        const id =
          params.get('id');

        // Drawer mode
        if (!entity && this.entity) {

          this.reloadForm(
            this.entity,
            this.recId
          );

          return;
        }

        if (!entity) {
          return;
        }

        this.reloadForm(
          entity,
          id ?? undefined
        );

      });

  }

  // ✅ Whenever parent changes recId -> reload record
  ngOnChanges(
    changes: SimpleChanges
  ): void {

    if (
      changes['entity'] ||
      changes['recId']
    ) {

      if (this.entity) {

        this.reloadForm(
          this.entity,
          this.recId
        );

      }

    }

  }
  
  private reloadForm(
    entity: string,
    recId?: string
  ): void {

    this.loading = true;

    this.entity = entity;

    this.recordId = recId;

    this.recId = recId;

    //
    // IMPORTANT
    //

    this.schemaLoaded = false;

    this.layout = undefined!;

    this.form = undefined!;

    this.loadSchemaOnce(() => {

      if (recId) {

        this.loadRecord(recId);

      }
      else {

        this.resetForCreate();

        this.loading = false;

      }

    });

  }

  private loadSchemaOnce(done?: () => void) {
    if (
        this.schemaLoaded &&
        this.layout
    ) {

        done?.();

        return;

    }

    if (!this.entity) return;

    this.api.getSchema(this.entity).subscribe({
      next: (schema) => {
        // 1. Map the schema (this won't crash now thanks to the fix above)
        this.layout = mapBackendSchema(schema);

        // 2. Only build the form if layout exists
        if (this.layout) {
          this.form = this.dfs.buildForm(this.layout);
          this.schemaLoaded = true;
        }

        this.loading = false;
        done?.();
      },
      error: (err) => {
        console.error('Schema Load Failed', err);
        this.loading = false;
        this.snackBar.open('Error loading form design', 'Close', { duration: 3000 });
      }
    });
  }
  private resetForCreate() {
    this.loading = true;  
    this.recordId = undefined;

    this.form?.reset();

    Object.keys(this.layout.fieldsMap)
      .forEach(key => {

        const ctrl =
          this.form.get(key);

        if(ctrl instanceof FormArray)
        {
          ctrl.clear();
        }
      });

    this.dfs.initializeRepeaterDefaults(
      this.form,
      this.layout
    );

    this.loading = false;
  }
  addLineRow() {
    this.dfs.addRepeaterRow(this.form, this.layout, 'lines');
  }

  removeLine(i: number) {
    (this.form.get('lines') as FormArray).removeAt(i);
  }

  loadRecord(id: string) {
    // ✅ STEP 1: Immediately hide the old form and show the spinner
    this.loading = true;

    // ✅ STEP 2: Immediately wipe the old data from memory
    this.resetForCreate();

    // Now, call the API
    this.api.getRecord(this.entity, id, this.layout.moduleCode).subscribe({
      next: (res: any) => {
        if (!res) {
          this.loading = false;
          return;
        }

        // PATCH STATIC ROOT
        Object.values(this.layout.fieldsMap)
        .filter(
          (f:any) =>
            !f.parentField
        )
        .forEach((f:any) => {

          let value =
            res[f.name];

          if (
            value === undefined ||
            value === null
          ) {
            return;
          }

          if (
            value === '{}' ||
            value === ''
          ) {
            value = null;
          }

          if (
            typeof value === 'string' &&
            value.startsWith('{')
          ) {
            try {

              value =
                JSON.parse(value);

            } catch {}
          }

          // Date fields
          if (
            f.type === 'datepicker' &&
            value
          ) {
            value = DateUtils.toDateInputValue(value);
          }

          this.form
            .get(f.name)
            ?.patchValue(
              value,
              {
                emitEvent:false
              }
            );

        });

        // PATCH ROOT DYNAMIC
        const dyn =
          typeof res.data_dynamic === 'string'
            ? JSON.parse(res.data_dynamic)
            : res.data_dynamic;

        Object.keys(dyn || {}).forEach((key) => {
          if (key !== 'lines' && this.form.get(key)) {
            this.form.get(key)?.patchValue(dyn[key]);
          }
        });

        // PATCH LINES
        const arr = this.form.get('lines') as FormArray;
        arr.clear();
        if (Array.isArray(res.lines)) {
          res.lines.forEach((ln: any) => {
            const merged = { ...ln.data_static, ...ln.data_dynamic, id: ln.id };
            this.dfs.addRepeaterRow(this.form, this.layout, 'lines', merged);
          });
        }

        this.recordId = id;

        // ✅ STEP 3: Only now, set loading to false to show the new data
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error('API Error', err);
      },
    });
  }
  // save() {
  //   // 1. Force UI to show red errors
  //   this.form.markAllAsTouched();

  //   // 2. Check Line Items
  //   const linesArray = this.form.get('lines') as FormArray;
  //   if (!linesArray || linesArray.length === 0) {
  //     alert('❌ Error: Please add at least one line item (row).');
  //     return;
  //   }

  //   // 3. Check Row-level validity (Empty fields inside rows)
  //   if (linesArray.invalid) {
  //     alert('❌ Error: Some fields inside your line items are empty or invalid.');
  //     return;
  //   }

  //   // 4. Check Grand Total (Number conversion is important)
  //   const total = Number(this.form.get('grand_total')?.value || 0);
  //   if (total < 1000) {
  //     alert(`❌ Error: Grand Total must be at least 1,000. (Current: ${total})`);
  //     return;
  //   }

  //   // 5. Final General Validity
  //   if (this.form.invalid) {
  //     alert('❌ Error: The form contains invalid data. Please check the red fields.');
  //     return;
  //   }

  //   // 6. IF ALL PASS -> API CALL
  //   console.log('Validation passed, saving...');

  //   const payload = this.dfs.getSubmitPayload(this.form, this.layout);
  //   const dto = { ...payload, Entity: this.entity };

  //   this.api.saveForm(this.entity, dto).subscribe({
  //     next: (res: any) => {
  //       console.log('SAVE RESPONSE:', res);

  //       const id = res?.recordId || res?.RecordId;

  //       if (!id) {
  //         alert('Saved but ID missing in response');
  //         return;
  //       }

  //       this.recordId = id;

  //       alert('Saved, id: ' + id);

  //       // ✅ AUTO-OPEN EDIT MODE
  //       window.history.replaceState({}, '', `/form/${this.entity}/${id}`);
  //       this.saved.emit(); // 🔥 notify list
  //     },

  //     error: (err) => {
  //       console.error(err);
  //       alert('Save failed');
  //     },
  //   });
  // }
  save() {
    this.api.getRules(this.entity).subscribe({
      next: (rules: any[]) => {
        console.log('Rules received from API:', rules); // Debugging
        const formValue = this.form.getRawValue(); // use getRawValue to include disabled fields
        const context = {
          header: formValue,
          // Check if your lines are directly in the form or inside a sub-object
          lineItems: formValue.lines || formValue.form?.lines || []
        };

        console.log('2. Validation Context:', context);

        const results = this.validationEngine.validate(context, rules);
        console.log('3. Validation Results:', results);

        const errors = results.filter((r: any) => r.severity === 'ERROR');

        if (errors.length > 0) {
          console.log('4. Validation Failed! Stopping save.');
          this.showValidationErrors(errors);
          return;
        }

        console.log('5. Validation Passed! Calling C# Save API...');
        this.executeApiSave();
      }
    });
  }

  private executeApiSave() {
    // Convert form to the Payload DTO your C# controller expects
    const payload = this.dfs.getSubmitPayload(this.form, this.layout);
    payload.moduleCode = this.layout.moduleCode;
    console.log('Payload being sent to C#:', payload);

    // this.api.saveForm(this.entity, payload).subscribe({
    //   next: (res: any) => {
    //     const id = res?.recordId || res?.RecordId;
    //     if (id) {
    //       alert('Saved Successfully! ID: ' + id);
    //       window.history.replaceState({}, '', `/form/${this.entity}/${id}`);
    //       this.saved.emit();
    //     }
    //   },
    //   error: (err) => {
    //     alert('Backend Save Error: ' + err.message);
    //   }
    // });
    this.api.saveForm(this.entity, payload).subscribe({
      next: (res: any) => {
        const id = res?.recordId || res?.RecordId;
        if (id) {
          // SUCCESS TOAST
          KTToast.show({
            icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`,
            message: `Saved Successfully! ID: ${id}`,
            appearance: 'solid',
            variant: 'success', // Green color for success
            duration: 5000,
          });

          window.history.replaceState({}, '', `/form/${this.entity}/${id}`);
          this.saved.emit();
        }
      },
      error: (err) => {
        // ERROR TOAST
        KTToast.show({
          icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-alert-circle"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>`,
          message: 'Backend Save Error: ' + err.message,
          appearance: 'solid',
          variant: 'danger', // Red color for error
          duration: 7000,    // Longer duration for errors so users can read them
        });
      }
    });
  }
  // ✅ THE FIX: Added the missing method
  // showValidationErrors(errors: any[]) {
  //   const errorMessage = errors
  //     .map((err, index) => `${index + 1}. ${err.message}`)
  //     .join('\n');

  //   alert('Validation Failed:\n\n' + errorMessage);
  // }
  showValidationErrors(errors: any[]) {
    // 1. Get the first error (The Line Item error, thanks to your SQL sort)
    const firstError = errors[0];
    const message = firstError.message || firstError.Message;

    // 2. Trigger Metronic KTToast
    KTToast.show({
      icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>`,
      message: message,
      appearance: 'solid',
      variant: 'mono',
      duration: 5000,

    });
  }
  update() {
    if (!this.recordId) {
      alert('No record id');
      return;
    }

    const payload = this.dfs.getSubmitPayload(this.form, this.layout);
    const dto = { ...payload, Entity: this.entity };

    this.api.updateForm(this.entity, this.recordId, dto).subscribe({
      next: () => {
        alert('Updated successfully');
      },
      error: (err) => {
        console.error('UPDATE ERROR:', err);
        alert('Update failed');
      },
    });
  }

  delete() {
    if (!this.recordId) return;
    if (!confirm('Delete?')) return;
    this.api.deleteForm(this.entity, this.recordId).subscribe(
      () => {
        alert('Deleted');
        this.form.reset();
        this.recordId = undefined;
      },
      (err) => alert('Delete error'),
    );
  }
  backToList() {
    const entity = this.route.snapshot.params['entity'];

    if (entity) {
      // If your base route in app-routing.module.ts is 'app', 
      // then '/app/general/trans' is correct.
      this.router.navigate(['/app/general/trans', entity]);
    }
  }
  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
  }

  getTaxRepeater(): any[] {

    // return this.layout.taxConfig
    //   ?.roles?.lineRepeater;
    return this.form.get('lines')?.getRawValue();
  }

  getTaxSummary() {

    return {

      subtotal:
        this.form.get(
          this.role('subtotal')
        )?.value,

      taxTotal:
        this.form.get(
          this.role('taxTotal')
        )?.value,

      grandTotal:
        this.form.get(
          this.role('grandTotal')
        )?.value
    };
  }
  private role(
    name: string
  ): string { 

    return (
      this.layout.taxConfig?.roles?.[name]
      ?? name
    );

  }

}
